import React from 'react';
import { Helmet } from 'react-helmet';
import {Container} from 'react-bootstrap';
import {Row, Col, Pagination} from 'antd';
import '@wartek-id/design-tokens/build/guru-desktop/css/color.css';
import qs from 'query-string';

const Category = ({pengumuman, category}) => {
  const handleChange = (page) => {
    setCurrentPage(page)
    const payload = {
      page: page,
      limit: 12
    }
    const cleanedPayload = Helper.cleanObject(payload)
    getList(`?${qs.stringify(cleanedPayload)}`)
  };
    return(
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Pengumuman | Situs Informasi SIPLah</title>
                <link rel="canonical" href="siplah.kemendikdasmen.go.id/info-berita/pengumuman" />
                <meta http-equiv="Cache-control" content="max-age=31536000"></meta>
                <meta name="title" content="Pengumuman | Situs Informasi SIPLah"></meta>
                <meta name="description" content="Lihat pengumuman terbaru, regulasi, informasi, dan liputan tentang SIPLah."></meta>
            </Helmet>
            <div className="h-100">
              <section className="bg-dark-blue text-white section-pertanyaan-umum">
                <Container>
                  <div className="d-flex m-b-24">
                    <a className="text-white" href="/info-berita">Info & Berita</a>
                    <span className="material-symbols-outlined">
                      navigate_next
                    </span>
                    {category?.name}
                  </div>
                  <h1 className="font-switzer-bold text-white"><b>{category?.name}</b></h1>
                </Container>
              </section>
              <section className="section-pertanyaan-umum">
                <Container>
                  <Row gutter={[16, 16]}>
                    {pengumuman?.list?.length > 0 && pengumuman?.list?.map((d,i)=>
                      <Col lg={8} md={12} sm={12} xs={24} key={i} className="m-b-24 p-r-12 p-l-12">
                        <a href={`/info-berita/${d.id}/detail`} className="category-berita card d-flex justify-space-between" style={{height: '100%'}}>
                          <img className="card-img-top" src={d.image_name} alt="Card image cap"/>
                          <div className="card-body">
                            <div className="font-size-14 primary-blue m-b-16 text-uppercase"><b>{d.published_at.split(" ")[0]} {d.published_at.split(" ")[1]} {d.published_at.split(" ")[2]}</b></div>
                            <div className="text-caption-header m-b-12 title"><b>{d.title}</b></div>
                            <div className="grey-text m-b-12">{d.excerpt.slice(0, 80)}</div>
                            <div>
                              <hr className="m-b-16 grey-text"/>
                              <div className="category-arrow font-size-14" >
                                <b className="d-flex align-items-center">
                                  Selengkapnya
                                  <div className="material-symbols-outlined m-l-16 text-subgrey">
                                    arrow_forward
                                  </div>
                                </b>
                              </div>
                            </div>
                          </div>
                        </a>
                      </Col>
                    )}
                  </Row>
                  <div className="text-center m-t-44 position-relative">
                    <Pagination
                      pageSize={pengumuman?.meta?.limit || 10}
                      current={pengumuman?.meta?.page || 1}
                      total={pengumuman?.meta?.total}
                      onChange={(page) => handleChange(page)}
                    />
                  </div>
                </Container>
              </section>
              <div className="display-flex overflow-x-hidden m-t-24">
                <span className="line-upper-footer bg-blue"/>
                <span className="line-upper-footer bg-orange"/>
                <span className="line-upper-footer bg-green"/>
                <span className="line-upper-footer bg-pink"/>
              </div>
            </div>
        </>
    )
}
export default Category;